export default "__VITE_ASSET__DtYDY8q1__"